<template>
  <div
    :id="id"
    v-if="!isDismissed"
    class="tutorial-box notification is-info is-light"
  >
    <button
      class="tutorial-box--dismiss-button delete is-medium"
      @click="dismiss"
      :title="$t('Hide this message')"
    ></button>
    <slot></slot>
  </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
  name: "TutorialBox",
  props: { id: String },
  methods: {
    dismiss() {
      this.$store.commit("addDismissedTutorialBoxId", this.id);
    },
  },
  computed: {
    isDismissed() {
      if (!this.$store.state.dismissedTutorialBoxIds) {
        return false;
      }

      return this.$store.state.dismissedTutorialBoxIds.indexOf(this.id) !== -1;
    },
  },
});
</script>
<i18n>
{
  "en": {},
  "de": {
    "Hide this message": "Nachricht verstecken"
  }
}
</i18n>
